<template>
  <div class="p-grid">
    <div class="p-col-12 p-d-flex p-justify-end">
      <Button
        @click="onAddNewCourse"
        icon="pi pi-plus"
        label="เพิ่มใหม่"
        :disabled="isReadOnly || isEmployee"
      ></Button>
    </div>
    <div class="p-col-12" v-if="isEmployee">
      กรุณาตรวจสอบหลักสูตร และหัวหน้างาน
      จากนั้นส่งเอกสารให้หัวหน้างานเพื่อทำการประเมินต่อไป
    </div>
    <div class="p-col-12" v-if="isEmployee">
      <DataTable
        :value="items"
        class="p-datatable-sm"
        responsiveLayout="scroll"
        dataKey="sort"
      >
        <template #empty="">ไม่พบข้อมูล</template>
        <Column
          field="courseId"
          bodyClass="p-fluid"
          header="รายละเอียดเนื้อหาที่ประเมิน"
        >
          <template #body="props">
            <InputCourse
              v-model="props.data.courseId"
              :disabled="props.data.mandatory || isReadOnly || isEmployee"
            ></InputCourse>
          </template>
        </Column>
      </DataTable>
    </div>
    <template v-else>
      <div class="p-col-12">
        <DataTable
          :value="supervisorItems"
          class="p-datatable-sm"
          responsiveLayout="scroll"
          dataKey="sort"
        >
          <template #empty="">ไม่พบข้อมูล</template>
          <Column
            field="courseId"
            bodyClass="p-fluid"
            header="รายละเอียดเนื้อหาที่ประเมิน"
          >
            <template #body="props">
              <InputCourse
                v-model="props.data.courseId"
                :disabled="props.data.mandatory || isReadOnly || isEmployee"
              ></InputCourse>
            </template>
          </Column>
          <Column
            header="มากที่สุด"
            field="item.answer"
            headerStyle="width:5rem"
            bodyStyle="width:5rem"
          >
            <template #body="props">
              <RadioButton
                v-model="props.data.answer"
                value="5"
                :disabled="isReadOnly || !isSupervisor"
              ></RadioButton>
            </template>
          </Column>
          <Column
            header="มาก"
            field="item.answer"
            headerStyle="width:5rem"
            bodyStyle="width:5rem"
          >
            <template #body="props">
              <RadioButton
                v-model="props.data.answer"
                value="4"
                :disabled="isReadOnly || !isSupervisor"
              ></RadioButton>
            </template>
          </Column>
          <Column
            header="ปานกลาง"
            field="item.answer"
            headerStyle="width:5rem"
            bodyStyle="width:5rem"
          >
            <template #body="props">
              <RadioButton
                v-model="props.data.answer"
                value="3"
                :disabled="isReadOnly || !isSupervisor"
              ></RadioButton>
            </template>
          </Column>
          <Column
            header="น้อย"
            field="item.answer"
            headerStyle="width:5rem"
            bodyStyle="width:5rem"
          >
            <template #body="props">
              <RadioButton
                v-model="props.data.answer"
                value="2"
                :disabled="isReadOnly || !isSupervisor"
              ></RadioButton>
            </template>
          </Column>
          <Column
            header="น้อยที่สุด"
            field="item.answer"
            headerStyle="width:5rem"
            bodyStyle="width:5rem"
          >
            <template #body="props">
              <RadioButton
                v-model="props.data.answer"
                value="1"
                :disabled="isReadOnly || !isSupervisor"
              ></RadioButton>
            </template>
          </Column>

          <Column headerStyle="width:5rem" bodyStyle="width:5rem">
            <template #body="props">
              <Button
                v-if="!props.data.mandatory"
                class="p-button-rounded p-button-danger"
                icon="pi pi-trash"
                @click="onDeleteItem(props.index)"
                :disabled="isReadOnly"
              ></Button>
            </template>
          </Column>
        </DataTable>
      </div>
      <div class="p-col-12" v-if="localIsComplete === false">
        <span style="font-size: 1.2rem; color:red; font-weight: bold"
          >กรุณาระบุข้อมูลให้ครบถ้วนก่อน</span
        >
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  PropType,
  watch,
  ref,
  computed,
  onMounted,
} from "vue";
import { PositionDocumentItem } from "@/types";
import InputCourse from "@/components/InputCourse.vue";

interface PositionItemDto {
  item: PositionDocumentItem;
  isSupervisor: boolean;
}

export default defineComponent({
  name: "PositionDocumentPanel",
  components: { InputCourse },
  props: {
    assessmentData: {
      type: String as PropType<string | null>,
      required: true,
    },
    supervisorAssessmentData: {
      type: String as PropType<string | null>,
      required: false,
    },
    isSupervisor: {
      type: Boolean,
      required: true,
    },
    isEmployee: {
      type: Boolean,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const items = ref<PositionDocumentItem[]>([]);
    const supervisorItems = ref<PositionDocumentItem[]>([]);
    // const mergeItems = computed<PositionItemDto[]>(() => {
    //   const result: PositionItemDto[] = [];
    //   if (props.isEmployee) {
    //     result.push(
    //       ...items.value.map<PositionItemDto>((x) => ({
    //         item: x,
    //         isSupervisor: false,
    //       }))
    //     );
    //   }
    //   if (props.isSupervisor) {
    //     result.push(
    //       ...supervisorItems.value.map<PositionItemDto>((x) => ({
    //         item: x,
    //         isSupervisor: true,
    //       }))
    //     );
    //   }

    //   // result.sort(
    //   //   (x, y) =>
    //   //     (x.item.sort - y.item.sort) * 10 +
    //   //     ((x.isSupervisor ? 1 : 0) - (y.isSupervisor ? 1 : 0))
    //   // );
    //   return result;
    // });

    watch(
      () => props.assessmentData,
      () => (items.value = JSON.parse(props.assessmentData ?? "[]"))
    );
    watch(
      () => props.supervisorAssessmentData,
      () =>
        (supervisorItems.value = JSON.parse(
          props.supervisorAssessmentData ?? "[]"
        ))
    );

    const localIsComplete = computed(() => {
      return (
        supervisorItems.value.filter((x) => !x.answer).length === 0 &&
        supervisorItems.value.filter((x) => !x.courseId).length === 0
      );
    });

    // const onInputValue = () => {

    // };
    watch(
      () => supervisorItems.value,
      () => {
        if (props.isSupervisor === true) {
          emit(
            "update:supervisorAssessmentData",
            JSON.stringify(supervisorItems.value)
          );
          emit("update:isComplete", localIsComplete.value);
        }
      },
      { deep: true }
    );

    const onAddNewCourse = () => {
      supervisorItems.value.push({
        courseId: "",
        courseDescription: "",
        mandatory: false,
        sort: 0,
        answer: null,
      } as PositionDocumentItem);
    };

    const onDeleteItem = (index: number) => {
      supervisorItems.value.splice(index, 1);
    };

    onMounted(() => {
      items.value = JSON.parse(props.assessmentData ?? "[]");
      supervisorItems.value = JSON.parse(
        props.supervisorAssessmentData ?? "[]"
      );
    });

    return {
      items,
      supervisorItems,
      onAddNewCourse,
      onDeleteItem,
      localIsComplete,
      // mergeItems,
      // isRadioReadonly,
    };
  },
});
</script>

<style></style>
